module.exports = __webpack_public_path__ + "img/vault.f6c8b9cd.png";